import actionTypes from 'src/modules/redux/actionTypes'

export const setCartItemsFetchedInitially = isLoading => ({
  type: actionTypes.SET_CART_ITEMS_FETCHED_INITIALLY,
  payload: isLoading
})
